<template>
    <div class="login-container">
        <head-bar title :fixed="true">
            <template v-slot:right>
                <div
                    class="head-right-slot"
                    @click="gotoView('/account/register')"
                >
                    <span>注册账号</span>
                </div>
            </template>
        </head-bar>
        <div class="login-caption">
            <span>欢迎登录油柑网</span>
        </div>
        <div class="login-form">
            <div class="form-item margin-b">
                <div class="input-icon person-icon"></div>
                <input
                    type="text"
                    v-model="loginInfo.userAccount"
                    class="input-common"
                    placeholder="手机号码 客户编号或邮箱"
                />
            </div>
            <div class="form-item">
                <div class="input-icon password-icon"></div>
                <input
                    type="password"
                    v-model="loginInfo.password"
                    class="input-common"
                    placeholder="输入密码"
                />
            </div>
        </div>
        <div class="login-btn" @click="login">
            <span>{{ isSumbitIng ? "登录中" : "登录" }}</span>
        </div>
        <div class="other-link">
            <div
                class="other-link-left"
                @click="
                    $router.push({
                        path: '/account/login/code',
                        query: {
                            phone: loginInfo.userAccount,
                        },
                    })
                "
            >
                <span>手机验证码登录</span>
            </div>
            <div
                class="other-link-right"
                @click="gotoView('/account/find/password')"
            >
                <span>忘记密码?</span>
            </div>
        </div>
        <div class="wechat-login" @click="wechatLogin" v-if="isBuildWechat">
            <van-divider> <i class="wechat-icon"></i>微信授权登录 </van-divider>
        </div>
    </div>
</template>
<script>
import wechatAuthorization from "@/utils/wechat";
import { build_wechat, build_h5 } from "@/helper/types/build";
import HeadBar from "@/components/HeadBar.vue";
import { setUserToken, setUserId, removeBasket } from "@/utils/auth";
import { isPhone, isEmpty } from "@/utils/validation";
import Vue from "vue";
import { Divider, Toast } from "vant";
Vue.use(Divider).use(Toast);
//登录类型
const LOGIN_TYPE_PASSWORD = 1;
export default {
    name: "PasswordLogin",
    components: {
        HeadBar,
    },
    data() {
        return {
            loginInfo: {
                userAccount: "",
                password: "",
            },
            isSumbitIng: false,
        };
    },
    beforeMount() {
        let { phone } = this.$route.query;
        if (phone) {
            this.loginInfo.userAccount = phone;
        }
    },
    mounted() {},
    methods: {
        login() {
            if (this.isSumbitIng) return;
            if (!this.validateLoginInfo(this.loginInfo)) return;
            let _this = this;
            _this.isSumbitIng = true;
            this.$axios
                .post(_this.$api.accountApi.login, {
                    userAccount: _this.loginInfo.userAccount,
                    passWord: _this.loginInfo.password,
                    loginType: LOGIN_TYPE_PASSWORD,
                    smsCode: "",
                })
                .then((response) => {
                    let { token, userId } = response.data;
                    _this.isSumbitIng = false;
                    setUserToken(token);
                    setUserId(userId);
                    removeBasket();
                    _this.$router.push({
                        path: "/",
                    });
                })
                .catch((error) => {
                    let { msg = "" } = error;
                    _this.$toast(msg);
                    _this.isSumbitIng = false;
                });
        },
        /**
         * @description 跳转页面
         */
        gotoView(path) {
            if (!path) return;
            this.$router.push({
                path: path,
            });
        },
        /**
         * @description 验证登录信息
         */
        validateLoginInfo(loginInfo) {
            let { password, userAccount } = loginInfo;
            if (isEmpty(userAccount)) {
                this.$toast("请输入正确的用户账户");
                return false;
            } else if (isEmpty(password)) {
                this.$toast("请输入登录密码");
                return false;
            }
            return true;
        },
        /**
         * @description 微信登录
         */
        wechatLogin() {
            //来源登陆
            const bind_source_login = 200;
            wechatAuthorization(bind_source_login);
        },
    },
    computed: {
        /**
         * @description 是否构建微信
         */
        isBuildWechat() {
            return this.$config.BUILD_TYPE === build_wechat;
        },
    },
};
</script>
<style lang="less" scoped>
.head-right-slot {
    padding-right: 35px;
    font-size: 32px;
    text-align: right;
    color: #333;
}
.login-container {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 50%;
    margin-left: -375px;
    width: 750px;
    height: 100%;
    background-image: url("../../public/images/account/login-bg.png");
    background-color: #fff;
    background-size: cover;
    background-repeat: no-repeat;
    .login-caption {
        padding-top: 170px;
        height: 160px;
        font-size: 48px;
        font-weight: 500;
        text-align: center;
        color: #333;
    }
    .login-form {
        margin: 0 auto;
        width: 550px;
        .form-item {
            position: relative;
            width: 550px;
            height: 90px;
            &.margin-b {
                margin-bottom: 15px;
            }
            .input-icon {
                position: absolute;
                z-index: 1;
                width: 48px;
                height: 48px;
                left: 0;
                top: 50%;
                margin-top: -24px;
                background-repeat: no-repeat;
                background-position: center;
                background-size: 48px;
                &.person-icon {
                    background-image: url("../../public/images/account/person-icon.png");
                }
                &.password-icon {
                    background-image: url("../../public/images/account/password-icon.png");
                }
            }
            .input-common {
                display: block;
                padding-left: 70px;
                width: 480px;
                height: 90px;
                background-color: #fff;
                border-top: none;
                border-bottom: 1px solid #f2f2f2;
                border-left: none;
                border-right: none;
                font-size: 32px;
                line-height: 90px;
                color: #333;
                &:focus {
                    border-bottom: 1px solid @theme-color;
                }
            }
        }
    }
    .login-btn {
        margin: 60px auto 40px;
        width: 550px;
        height: 80px;
        border-radius: 50px;
        background-color: @theme-color;
        font-size: 34px;
        line-height: 80px;
        text-align: center;
        color: #fff;
    }
    .other-link {
        overflow: hidden;
        margin: 0 auto;
        width: 550px;
        .other-link-left,
        .other-link-right {
            font-size: 28px;
        }
        .other-link-left {
            float: left;
            width: 50%;
            text-align: left;
            color: @theme-color;
        }
        .other-link-right {
            float: right;
            width: 50%;
            text-align: right;
            font-size: 28px;
        }
    }
    .wechat-login {
        margin: 160px auto 0px;
        width: 550px;
        .wechat-icon {
            *display: inline;
            zoom: 1;
            display: inline-block;
            margin-right: 20px;
            width: 52px;
            height: 52px;
            background-image: url("../../public/images/account/wechat-icon.png");
            background-size: 52px;
            background-repeat: no-repeat;
        }
    }
}
</style>
